/* prettier-ignore */
import { Injectable, Injector, inject } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { PostLoginRedirect } from '../services/post-login-redirect.service';
import { UserService } from '../../user/services';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    private _postLoginRedirect = inject(PostLoginRedirect);
    private _injector = inject(Injector);

    constructor(
        private router: Router,
        private authService: AuthService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const user = this.authService.user();
        if (user) return true;

        // HRS-3134: la web no tiene pantalla de login, es un modal. Antes se navegaba
        // a '/account/login' con un returnUrl que nadie leía, y esa ruta no existe:
        // quien abría un enlace directo a su cuenta —el del correo del registro, por
        // ejemplo— acababa en una pantalla vacía. Ahora se le deja en la home con el
        // login abierto y, al entrar, se le lleva a donde iba.
        this._postLoginRedirect.remember(state.url);

        // Perezoso a propósito: UserService arrastra los modales de la webapp y
        // pedirlo en el constructor del guard cerraría un círculo de dependencias.
        this.router.navigate(['/home']).then(() => this._injector.get(UserService).login());

        return false;
    }
}